/*=========================================================================================
  File Name: moduleScheduleMutations.js
  Description: Schedule Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	UPDATE_FREQUENCY(state, item) {
		const itemIndex = state.frequencyList.findIndex((p) => p.id === item.id);
		if (itemIndex !== -1) {
			Object.assign(state.frequencyList[itemIndex], item);
		}
	},
	SET_SCHEDULE_LABELS_STATUS(state, labels) {
		state.eventSatusLabels = labels;
	},
	UPDATE_EVENT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.id === event.event_id);
		Object.assign(state.events[eventIndex], {
			...event,
			calendarId: event.init_hour + event.event_id,
			status_id: 5,
		});
	},
	REMOVE_EVENT(state, event) {
		const eventIndex = state.events.findIndex((e) => e.id === event.event_id);
		state.events.splice(eventIndex, 1);
	},
	CLEAN_EVENTS(state) {
		state.events = [];
	},
	SET_FREQUENCY(state, items) {
		state.frequencyList = [...items];
	},
	REMOVE_FREQUENCY(state, itemId) {
		const ItemIndex = state.frequencyList.findIndex((p) => p.id === itemId);
		state.frequencyList.splice(ItemIndex, 1);
	},
	REMOVE_ALL_FREQUENCY(state) {
		state.frequencyList = [];
	},
	SET_CRON_EXPRESSION(state, item) {
		state.cronExpression = item;
	},
	SET_ASSIGNED_FREQUENCY(state, items) {
		let arrayNew = state.assignedFrequencies.concat(
			items.filter((element) => state.assignedFrequencies.find((e) => e.id === element.id) === undefined)
		);
		state.assignedFrequencies = arrayNew;
	},
	REMOVE_ASSIGNED_FREQUENCY(state, itemId) {
		const ItemIndex = state.assignedFrequencies.findIndex((p) => p.id === itemId);
		state.assignedFrequencies.splice(ItemIndex, 1);
	},
	REMOVE_ALL_ASSIGNED_FREQUENCY(state) {
		state.assignedFrequencies = [];
	},
	ADD_FREQUENCY_CHECKED(state, item) {
		const itemIndex = state.checkedFrequencies.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedFrequencies.push(item);
		}
	},
	SET_FREQUENCY_CHECKED(state, items) {
		state.checkedFrequencies = [...items];
	},
	REMOVE_FREQUENCY_CHECKED(state, item) {
		const itemIndex = state.checkedFrequencies.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedFrequencies.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_FREQUENCY_CHECKED(state) {
		state.checkedFrequencies = [];
	},
};
